module.exports = __webpack_public_path__ + "img/DirectionSwitch.2ffdd18d.png";